var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "j-modal",
    {
      attrs: {
        title: _vm.language["system.languageManagement"],
        width: 700,
        visible: _vm.visible,
        switchFullscreen: "",
        maskClosable: false,
        confirmLoading: _vm.confirmLoading,
        okText: _vm.language["common.okButton"],
        "ok-disabled": _vm.isDisabled,
        okButtonProps: { class: { "jee-hidden": _vm.isDisabled } },
        cancelText: _vm.language["common.closeButton"]
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel }
    },
    [
      _c(
        "a-spin",
        { attrs: { spinning: _vm.confirmLoading } },
        [
          _c(
            "a-form-model",
            _vm._l(_vm.languagelist, function(item, index) {
              return _c(
                "div",
                { key: index },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: _vm.language[item.templateLangCode]
                      }
                    },
                    [
                      _c("a-input", {
                        attrs: {
                          type: "text",
                          maxLength: "maxLength",
                          disabled: _vm.isDisabled || _vm.disabled
                        },
                        model: {
                          value: item.langTrans,
                          callback: function($$v) {
                            _vm.$set(item, "langTrans", $$v)
                          },
                          expression: "item.langTrans"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            }),
            0
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }